import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { Table, Layout, Space, Row, Col, Button, Tooltip } from 'antd'
import {
  StopOutlined,
  CheckCircleOutlined,
  EditOutlined,
  DeleteOutlined
} from "@ant-design/icons"

import usePaginate from '../../firebase/hooks/usePaginate'
import FireStoreSearch from "../../components/FilterSearch"
import { useAuth } from "../../contexts/AuthContext"
import PageLimitDropDown from "../../components/PageLimitDropDown"
import { statusLabel } from "../../utils/labels"
import useUsers from "../../firebase/hooks/useUsers"
import {countryNameByIso2} from "../../data/countries"

const { Content } = Layout

const table = "users"
const where = ['role', '==', 'agent']

const searchOptions = [
  {
    'key': 'firstName',
    'label': 'First Name'
  },
  {
    'key': 'lastName',
    'label': 'Last Name'
  },
  {
    'key': 'email',
    'label': 'Email'
  }
]

const Agent = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const { user } = useAuth()
  const [list, setList] = useState([])
  const [showMore, setShowMore] = useState(true)
  const { approveUser, blockUser, deleteConfirm } = useUsers()

  const {
    loading,
    loadingMore,
    hasMore,
    items,
    loadMore
  } = usePaginate(table, {
    where: where,
    limit: user.limit
  })

  useEffect(() => {
    setList(items)
  }, [items])

  const setResult = async (list, searchLength) => {
    if (searchLength > 1) {
      setList(list)
      setShowMore(false)
    } else {
      setList(items)
      setShowMore(true)
    }
  }

  const columns = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.firstName.length - b.firstName.length,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.lastName.length - b.lastName.length,
      sortDirections: ['ascend', 'descend'],
      responsive: ['md'],
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.email.length - b.email.length,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Country',
      dataIndex: 'iso2',
      key: 'iso2',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.iso2.length - b.iso2.length,
      sortDirections: ['ascend', 'descend'],
      render: (iso2) => <div>{countryNameByIso2(iso2)}</div>
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.status.length - b.status.length,
      sortDirections: ['ascend', 'descend'],
      responsive: ['md'],
      render: (status) => <span>{statusLabel(status)}</span>
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (id, row) => (
        <Space size="middle">
          {/* https://firebase.google.com/docs/auth/admin/manage-users#update_a_user */}
          {false &&
            <Tooltip title="Edit">
              <EditOutlined onClick={() => history.push(`${pathname}/edit/${id}`, row)} />
            </Tooltip>
          }
          {(row.status === 'p' || row.status === 'b') &&
            <Tooltip title="Approve">
              <CheckCircleOutlined onClick={() => approveUser(id)} style={{ color: "#00ff00" }} />
            </Tooltip>
          }
          {row.status === 'a' &&
            <Tooltip title="Block">
              <StopOutlined onClick={() => blockUser(id)} style={{ color: "#ff0000" }} />
            </Tooltip>
          }
          <Tooltip title="Delete">
            <DeleteOutlined style={{ color: "#ff0000" }} onClick={() => deleteConfirm(row)} />
          </Tooltip>
        </Space>
      )
    }
  ]

  const onChange = (data) => {
    console.log(data)
  }

  return (
    <Content>
      {/* <Breadcrumb>
        <Breadcrumb.Item>Banks</Breadcrumb.Item>
      </Breadcrumb> */}
      <div className="" style={{ padding: 16, minHeight: 360 }}>
        <Row justify="space-between">
          <Col>
            <FireStoreSearch table={table} searchOptions={searchOptions} setResult={setResult} />
          </Col>
          <Col>
            {/* <Button type="primary" style={{ marginBottom: "1em" }}><Link to={`${pathname}/add`}>Add Bank</Link></Button> */}
          </Col>
        </Row>
        <Table
          rowKey="id"
          dataSource={list}
          columns={columns}
          loading={loading}
          onChange={onChange}
          pagination={false}
        />
        <Row justify="space-between" style={{ marginTop: "1.5em" }}>
          <Col>
            <PageLimitDropDown />
          </Col>
          <Col>
            {showMore && hasMore && !loadingMore && <Button type="primary" onClick={loadMore}>Load More</Button>}
            {loadingMore && <Button type="primary" loading>Loading...</Button>}
          </Col>
        </Row>
      </div>
    </Content>
  )
}

export default Agent
